'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'circle-dollar';
var width = 512;
var height = 512;
var aliases = ["dollar-circle","usd-circle"];
var unicode = 'f2e8';
var svgPathData = ['M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-392v15.8c10.8 1.3 21.6 4.4 32.2 7.4c2.1 .6 4.1 1.2 6.2 1.7c12.8 3.5 20.3 16.8 16.8 29.5s-16.8 20.3-29.5 16.7c-1.7-.5-3.4-1-5.2-1.4c-7.8-2.2-15.6-4.4-23.5-5.9c-14.6-2.8-31.6-1.5-45.4 4.4c-12.3 5.3-22.3 18.2-8.4 27.1c10.9 7 24.2 10.6 36.8 14c2.6 .7 5.2 1.4 7.8 2.1c17.3 4.9 39.5 11.2 56.1 22.6c21.6 14.8 31.7 38.8 26.9 64.6c-4.6 24.9-21.9 41.2-42.7 49.6c-8.7 3.5-18.1 5.7-28 6.9l0 16.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-19.3c-16.1-3.6-31.9-8.8-47.5-13.9c-12.6-4.2-19.4-17.7-15.3-30.3s17.7-19.4 30.3-15.3c2.8 .9 5.6 1.9 8.4 2.8c12.6 4.3 25.4 8.6 38.3 10.6c18.9 2.8 34 1.1 43.9-2.9c13.4-5.4 19.6-21.2 6.6-30.1c-11.2-7.7-25.1-11.4-38.4-15c-2.5-.7-5-1.4-7.5-2.1c-16.8-4.7-37.7-10.7-53.5-20.8c-21.7-13.8-32.7-37-28-62.6c4.5-24.3 23.3-40.4 43.3-49c6.1-2.6 12.6-4.7 19.5-6.3V120c0-13.3 10.7-24 24-24s24 10.7 24 24z', 'M256 96c13.3 0 24 10.7 24 24v15.8c12.9 1.6 25.8 5.6 38.4 9.1c12.8 3.5 20.3 16.8 16.8 29.5s-16.8 20.3-29.5 16.7c-9.5-2.6-19-5.5-28.7-7.3c-14.6-2.8-31.6-1.5-45.4 4.4c-12.3 5.3-22.3 18.2-8.4 27.1c13.2 8.4 29.7 11.9 44.6 16.1c17.3 4.9 39.5 11.2 56.1 22.6c21.6 14.8 31.7 38.8 26.9 64.6c-4.6 24.9-21.9 41.2-42.7 49.6c-8.7 3.5-18.1 5.7-28 6.9l0 16.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-19.3c-16.1-3.6-31.9-8.8-47.5-13.9c-12.6-4.2-19.4-17.7-15.3-30.3s17.7-19.4 30.3-15.3c15.2 5 30.9 11 46.7 13.4c18.9 2.8 34 1.1 43.9-2.9c13.4-5.4 19.6-21.2 6.6-30.1c-13.4-9.1-30.5-12.7-45.9-17.1c-16.8-4.7-37.7-10.7-53.5-20.8c-21.7-13.8-32.7-37-28-62.6c4.5-24.3 23.3-40.4 43.3-49c6.1-2.6 12.6-4.7 19.5-6.3V120c0-13.3 10.7-24 24-24z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleDollar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;